export const accountType = [{
  text: 'USD',
  value: 'USD'
},
{
  text: 'VES',
  value: 'VES'
}
]

export const documentType = [{
  text: 'V',
  value: 'V'
},
{
  text: 'J',
  value: 'J'
},
{
  text: 'R',
  value: 'R'
}

// {
//   text: 'E',
//   value: 'E'
// },
// {
//   text: 'G',
//   value: 'G'
// }
]

export const userRoles = {
  ADMIN: 1,
  CLIENT: 2,
  CASHIER: 3,
  DELIVERY: 4,
  TICKETMASTER: 5
}

export const purchaseStatus = {
  PURCHASE_VERIFIED: 1,
  PURCHASE_NOT_VERIFIED: 2,
  PURCHASE_SHIPPED: 3,
  PURCHASE_DELIVERED: 4,
  PURCHASE_RECEIVED: 5,
  PURCHASE_CANCELLED: 6,
  PURCHASE_REJECTED: 7
}

export const paymentStatus = {
  NOT_PAID: 0,
  PAID: 1,
}